module.exports = __webpack_public_path__ + "src/assets/img/bg.03ddbb0d.png";